var _rect, _rect2, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSilverBatch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "url(#paint0_linear_13655_98492)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#C0C0C0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3029 13.9727L19.7873 17.0063L20.8583 21.5431C20.9174 21.7893 20.9022 22.0476 20.8146 22.2852C20.727 22.5229 20.5709 22.7292 20.3661 22.8782C20.1613 23.0271 19.9169 23.1121 19.6639 23.1222C19.4108 23.1324 19.1604 23.0673 18.9443 22.9352L14.999 20.5071L11.0513 22.9352C10.8352 23.0666 10.5851 23.131 10.3325 23.1205C10.0799 23.11 9.83603 23.0249 9.63163 22.8761C9.42724 22.7272 9.27146 22.5212 9.1839 22.284C9.09634 22.0468 9.08093 21.789 9.1396 21.5431L10.2146 17.0063L6.69897 13.9727C6.5078 13.8075 6.36954 13.5896 6.30146 13.3463C6.23338 13.103 6.2385 12.845 6.31617 12.6045C6.39385 12.3641 6.54064 12.1518 6.73822 11.9943C6.93579 11.8368 7.17539 11.741 7.4271 11.7188L12.0365 11.347L13.8146 7.04384C13.9108 6.80932 14.0747 6.60872 14.2852 6.46754C14.4957 6.32636 14.7435 6.25098 14.997 6.25098C15.2505 6.25098 15.4983 6.32636 15.7088 6.46754C15.9194 6.60872 16.0832 6.80932 16.1794 7.04384L17.9568 11.347L22.5662 11.7188C22.8184 11.7402 23.0587 11.8354 23.257 11.9927C23.4553 12.15 23.6027 12.3624 23.6809 12.6031C23.759 12.8438 23.7644 13.1023 23.6963 13.3461C23.6283 13.5898 23.4898 13.8081 23.2982 13.9735L23.3029 13.9727Z",
    fill: "#666D80"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_13655_98492)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 8,
    r: 3,
    fill: "#ECEFF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_13655_98492",
    x: 15,
    y: 1,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_13655_98492"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13655_98492",
    x1: 0,
    y1: 0,
    x2: 30,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverBatch);
export default __webpack_public_path__ + "static/media/silverBatch.830938e27cb4b40220d3f5ad326c3e0c.svg";
export { ForwardRef as ReactComponent };